<template>
  <div
    id="main"
    v-loading="loading"
    element-loading-text="Downloading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.5)"
    :style="{ overflow: loading ? 'hidden' : '' }"
  >
    <div class="top">
      <common-header></common-header>
    </div>
    <div class="content">
      <router-view @update:loading="updateLoading"></router-view>
    </div>
  </div>
</template>

<script>
import CommonAside from "../components/CommonAside.vue";
import CommonHeader from "../components/CommonHeader.vue";
import CommonTag from "../components/CommonTag.vue";

export default {
  data() {
    return {
      loading: false,
    };
  },
  components: {
    CommonAside,
    CommonHeader,
    CommonTag,
  },
  methods: {
    updateLoading(isLoading) {
      this.loading = isLoading;
    },
  },
};
</script>
<style lang="less" scoped>
#main {
  height: 100vh;

  .top {
    z-index: 999;
    width: 100%;
    position: fixed;
    top: 0;
    background-color: white;
    height: 70px;
  }

  .content {
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    border: 1px solid transparent;
    padding-top: 70px;
  }

  /deep/.el-icon-loading {
    font-size: 50px;
  }
  /deep/.el-loading-spinner i {
    color: #e0a9ac;
  }
  /deep/ .el-loading-spinner .el-loading-text {
    color: #e0a9ac;
    font-size: 20px;
  }
}
</style>